import { render } from "./SearchView.vue?vue&type=template&id=13cf201b&ts=true"
import script from "./SearchView.vue?vue&type=script&lang=ts"
export * from "./SearchView.vue?vue&type=script&lang=ts"

import "./SearchView.vue?vue&type=style&index=0&id=13cf201b&lang=postcss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__